import {Vector2} from "../utils/Vector2";


export interface SpriteSettings {

    pivot: Vector2
    scale: number
    extension: string
}

export class Sprite {

    id: string
    pivot: Vector2 = new Vector2(0.5, 0.5)
    scale: number = 1
    file: LoadedFile;

    constructor(options?: Partial<Sprite>) {
        Object.assign(this, options)
    }
}

export type SpriteLoadData = string | {
    id: string
    settings: Partial<SpriteSettings>
}

const defaults: SpriteSettings = {
    pivot: new Vector2(0.5, 0.5),
    scale: 1,
    extension: "png"
}

export class SpriteDatabase {

    sprites: { [key: string]: Sprite } = {}
    fileLoader: FileLoader
    basePath:string


    constructor(options: Partial<SpriteDatabase>) {

        Object.assign(this, options)
    }

    async loadSprites(...sprites: SpriteLoadData[]) {

        const newSprites = Object.fromEntries(await Promise.all(sprites.map(async spriteIdOrData => {

            let spriteId: string;
            let userImportSettings: Partial<SpriteSettings>;

            if (typeof spriteIdOrData === "string") {
                userImportSettings = undefined;
                spriteId = spriteIdOrData;
            } else {
                userImportSettings = spriteIdOrData.settings;
                spriteId = spriteIdOrData.id;
            }


            const importSettings = Object.assign({}, defaults, userImportSettings)
            const url =`${this.basePath}${spriteId}.${importSettings.extension}`
            try {
                const sprite = new Sprite({
                    id: spriteId,
                    file: await this.fileLoader.get(spriteId,url),
                    pivot: importSettings.pivot,
                    scale: importSettings.scale
                })

                return [sprite.id, sprite]
            } catch (e) {
                throw new Error(`Can't load sprite:${spriteId}`)
            }
        })))

        Object.assign(this.sprites, newSprites)

        return sprites
    }
}


export class FileLoader {

    loaded: { [id: string]: LoadedFile } = {}

    constructor(options?: Partial<FileLoader> ) {

        Object.assign(this, options)
    }


    async loadAtlas(atlasId, url) {

        const image = await loadImage(`${url}`)
        const metadata = await loadJson(`${url.substr(0,url.lastIndexOf("."))}.json`)

        for (const spriteId in metadata.frames) {
            const sprite = metadata.frames[spriteId]
            const id = `${atlasId}-${spriteId}`
            if (this.loaded[id]) {
                console.warn(`file already exists: ${id}`)
                continue
            }

            this.loaded[id] = {
                image: image,
                frame: sprite.frame
            }
        }

    }

    async get(id,url) {
        if (!this.loaded[id]) {
            this.loaded[id] = {
                image: await loadImage(url)
            }
        }

        return this.loaded[id]
    }
}

interface LoadedFile {
    image: HTMLImageElement
    frame?: { x: number, y: number, w: number, h: number }
}

async function loadJson(url) {

    const response = await fetch(url)
    const data = await response.json()
    return data
}

async function loadImage(url) {
    return new Promise<HTMLImageElement>((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => {
            resolve(image);
        });
        image.addEventListener('error', (e) => {
            //console.error(e)
            reject(e);
        });
        image.src = url;
    });
}